var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-root"}},[_c(_vm.layout,{tag:"component"}),_c('noti-modal',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"isGlobal":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }